import { render, staticRenderFns } from "./bc-iso-certificate.vue?vue&type=template&id=49b56aae&"
import script from "./bc-iso-certificate.vue?vue&type=script&lang=js&"
export * from "./bc-iso-certificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports